import React from 'react'
import { Grid as BaseGrid, styled, Hidden as BaseHidden } from '@mui/material'
import { ExpandMore as BaseExpandMore } from '@mui/icons-material'

export const Root = styled('div')`
  box-sizing: border-box;
  padding: 0 0 130px;
  width: 100%;
`

export const DesktopNavigation = styled('div')`
  display: flex;

  ${props => props.theme.breakpoints.down('md')} {
    justify-content: center;
  }
`

export const MobileNavigation = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: flex;
  height: 90px;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};

  &.MuiGrid-item {
    margin: ${props => props.margin || 'initial'};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.custom.mineShaft};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 31px;
  margin: 25px 0 0 0;
  text-align: center;

  ${props => props.theme.breakpoints.down('sm')} {
    font-size: 22px;
    line-height: 26px;
    margin: 15px 0 0 0;
  }
`

export const Instructions = styled('p')`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 1.3;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const AccessInstructions = styled('p')`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  margin: 0;
`

export const Username = styled('span')`
  background-color: ${props => props.theme.palette.green[95]};
  border: 1px solid ${props => props.theme.palette.green[75]};
  color: ${props => props.theme.palette.custom.charcoal};
  display: inline-block;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  margin: 18px 0 36px;
  padding: 6px 60px;
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const StrongToast = styled('strong')`
  color: ${props => props.theme.palette.brand.black1};
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
`

export const ItemCollapseIcon = styled(BaseExpandMore)`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 22px;
`
export const ExpandMore = styled(BaseExpandMore)`
  color: ${props => props.theme.palette.brand.black3};
  cursor: pointer;
  font-size: 12px;
`
export const Hidden = styled(BaseHidden)``

export const ToastContainer = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;

  & span {
    font-feature-settings:
      'liga' off,
      'clig' off;
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    font-style: normal;
    line-height: 18px;
    color: ${props => props.theme.palette.brand.black1};
  }
`

export const Divider = styled('div')`
  margin-bottom: 15px;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand[props.color]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-decoration-line: ${props => (props.underline ? 'underline' : 'inherit')};

  &:hover {
    color: ${({ color, theme }) => {
      switch (color) {
        case 'primary':
          return theme.palette.blue[35]
        case 'black2':
          return theme.palette.brand.black3
        default:
          return 'inherit'
      }
    }};
  }
`

export const Image = styled('img')`
  width: 130px;
  margin-top: 45px;
  margin-bottom: 45px;
`

export const Grid = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0'};
  }
`

export const SectionInputContainer = styled(Section)`
  input {
    background: ${props => props.theme.palette.brand.white};
    display: flex;
    text-align: left;
  }

  label {
    color: ${props => props.theme.palette.brand.black1};
    text-align: left;
  }
`

export const ImageContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
`

export const ReceiptContainer = styled('div')`
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding: 12px;
  ${props => props.theme.breakpoints.down('sm')} {
    text-align: left;
  }
`
export const ReceiptNumber = styled('span')`
  font-weight: bold;
  font-size: 30px;
  ${props => props.theme.breakpoints.down('sm')} {
    font-size: 26px;
  }
`

export const DividerWrapper = styled('div')`
  display: flex;
  align-items: center;
`

export const StyledHR = styled('hr')`
  flex-grow: 1;
  border-top: 1px solid ${props => props.theme.palette.brand.gray2};
`

export const DividerText = styled('span')`
  margin: 0 10px;
`
